export default __webpack_public_path__ + "static/media/1-blop.44db127d.png";